import { EXPORT_READ_API_PREFIX } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { QueryOptions, useBaseQuery } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { GetExportLinkRequest, GetExportLinkResponse } from './types';

export function useGetExportLinkApi(
  request: GetExportLinkRequest,
  options?: QueryOptions
) {
  const workspace = useWorkspace()?.id ?? '';
  const { id, type, status } = request;
  return useBaseQuery<GetExportLinkRequest, GetExportLinkResponse>(
    [useGetExportLinkApi.name, id, type, status],
    {
      url: `${EXPORT_READ_API_PREFIX.replace(':wid', workspace).replace(
        ':id',
        id
      )}`,
      method: HttpMethod.get,
      params: {
        return: 'link',
        type,
      },
    },
    options
  );
}
